import type { FetchConfig } from '@nlo/nuxt-common/api/helper-types';
import type { components, paths } from '../../generated/portal-api';

export function createResponsibleGamingApi(fetchConfig: FetchConfig) {
	const client = fetchConfig.createClient<paths>();

	return {
		getAgeValidationState() {
			return client.GET('/api/my/common/responsible-gaming/age-validation');
		},

		getPerformAgeValidationUrl(request: components['schemas']['IdinAgeValidationRequestViewModel']) {
			return client.POST('/api/my/common/responsible-gaming/age-validation', { body: request });
		},
	};
}
